import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCrLinkDaLimulo } from '@/hooks/useCrLinkDaLimulo';
import { useHaptics } from '@/hooks/useHaptics';

/**
 * Cosa dice una parte di Decks quando QBot risponde «nessun account collegato».
 *
 * Fuori dal ramo Limulo e' l'invito di sempre: la frase e il tasto «Collega» verso `/cr/link`.
 * NEL ramo Limulo QBot puo' dire «non collegato» anche a chi ha il profilo CR su Limulo
 * (il Sit&Go scrive li', QBot legge una tabella sua), e li' il tasto sarebbe una bugia:
 *  - profilo Limulo presente ⇒ NIENTE «collega». Le parti che dipendono dai dati di QBot
 *    (advisor, i mazzi salvati) arriveranno quando QBot leggera' anche il profilo Limulo:
 *    lo si dice, senza promettere una data. Sparisce da solo appena QBot smette di rispondere
 *    «non collegato».
 *  - profilo Limulo assente ⇒ «Collega» per davvero, ma verso la strada del Sit&Go
 *    (`limuloProfileCreateUrl`), non verso `/cr/link` (che su staging finisce su qduels di
 *    produzione e non puo' riuscire).
 *  - lettura di Limulo fallita ⇒ si dice che non si e' potuto leggere;
 *  - PIU' DI UN profilo CR attivo ⇒ si dice il fatto («ne serve uno solo, scrivi al supporto»): QBot non
 *    sceglie per ordine di lista, e senza la frase sarebbe un'attesa senza fine con un messaggio rassicurante.
 *    Niente tasto: la TMA non sa disattivare un profilo («Ricollega, non scollega», `LimuloProfiles.tsx`;
 *    nessuna azione di archiviazione in `src/`).
 */
export function NotLinkedNotice() {
  const { t } = useTranslation('cr');
  const haptics = useHaptics();
  const navigate = useNavigate();
  const crLink = useCrLinkDaLimulo();

  if (crLink.kind === 'loading') return null;

  if (crLink.kind === 'linked' || crLink.kind === 'unknown') {
    const testo =
      crLink.kind === 'linked'
        ? t('panel.link.limuloPending')
        : crLink.motivo === 'piuProfili'
          ? // NON la frase intera: in Decks la riga rossa in cima (`DecksPanel`) la dice gia', e ripeterla nel
            // corpo la mostrava due volte (revisione di #506, 3° giro, 🟢). Qui la CONSEGUENZA.
            t('crLink.moreProfilesBody')
          : t('panel.link.limuloUnknown');
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
        <p className="max-w-[16rem] text-sm text-fg-muted">{testo}</p>
      </div>
    );
  }

  const href = crLink.kind === 'notLinked' ? crLink.createHref : '/cr/link';
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
      <p className="max-w-[16rem] text-sm text-fg-muted">{t('panel.link.prompt')}</p>
      <button
        type="button"
        onClick={() => {
          haptics.impact('light');
          navigate(href);
        }}
        className="rounded-lg bg-brand px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-brand-fg"
      >
        {t('panel.link.cta')}
      </button>
    </div>
  );
}
